import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetCollection_pointsInvoices_invoiceIdDownload = z.any()
export type TagsGetCollection_pointsInvoices_invoiceIdDownload = z.infer<typeof tagsGetCollection_pointsInvoices_invoiceIdDownload>

export const descriptionGetCollection_pointsInvoices_invoiceIdDownload = z.any()
export type DescriptionGetCollection_pointsInvoices_invoiceIdDownload = z.infer<typeof descriptionGetCollection_pointsInvoices_invoiceIdDownload>

export const paramsGetCollection_pointsInvoices_invoiceIdDownload = z.object({ "invoiceId": z.string().uuid() })
export type ParamsGetCollection_pointsInvoices_invoiceIdDownload = z.infer<typeof paramsGetCollection_pointsInvoices_invoiceIdDownload>

export const querystringGetCollection_pointsInvoices_invoiceIdDownload = z.object({ "fileName": z.string().optional() })
export type QuerystringGetCollection_pointsInvoices_invoiceIdDownload = z.infer<typeof querystringGetCollection_pointsInvoices_invoiceIdDownload>

export const responseGetCollection_pointsInvoices_invoiceIdDownload = z.any()
export type ResponseGetCollection_pointsInvoices_invoiceIdDownload = z.infer<typeof responseGetCollection_pointsInvoices_invoiceIdDownload>

interface IGetCollection_pointsInvoices_invoiceIdDownload extends BaseMethodType {
  tags: TagsGetCollection_pointsInvoices_invoiceIdDownload,
  description: DescriptionGetCollection_pointsInvoices_invoiceIdDownload,
  params: ParamsGetCollection_pointsInvoices_invoiceIdDownload,
  querystring: QuerystringGetCollection_pointsInvoices_invoiceIdDownload,
  response: ResponseGetCollection_pointsInvoices_invoiceIdDownload
}
export const URL = '/collection-points/invoices/:invoiceId/download'
export const validation = {
  get: {
    tags: tagsGetCollection_pointsInvoices_invoiceIdDownload,
    description: descriptionGetCollection_pointsInvoices_invoiceIdDownload,
    params: paramsGetCollection_pointsInvoices_invoiceIdDownload,
    querystring: querystringGetCollection_pointsInvoices_invoiceIdDownload,
    response: responseGetCollection_pointsInvoices_invoiceIdDownload
  }
}
export interface Collection_pointsInvoices_invoiceIdDownload extends BaseRouteType {
  get: IGetCollection_pointsInvoices_invoiceIdDownload
}